
export const sortByOrderAscending = (components) => {
    return [...components].sort((a, b) => a.Order - b.Order);
}

export const generateRandomColorWithLighter = (value) => {
    const colors = [
        { original: '#2563EB', lighter: '#DBEAFE' }, // Blue
        { original: '#CA8A04', lighter: '#FEF9C3' }  // Yellow
    ];

    const picked = colors[Math.floor(value * colors.length)];
    return picked;
}